import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PaymentModal from "./payment";
import SaleOrderModal from "../sale/order";
import PurchaseOrderModal from "../purchase/purchaseOrder";
import AddStockModal from "./AddStock";
import { getItems } from "../../services/services";

const TransactionModal = ({ show, onHide, party, onPaymentSuccess }) => {
  const navigate = useNavigate();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentType, setPaymentType] = useState("payment-in");

  const [showSaleOrderModal, setShowSaleOrderModal] = useState(false);
  const [showPurchaseOrderModal, setShowPurchaseOrderModal] = useState(false);

  const [products, setProducts] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  const fetchProducts = async () => {
    const res = await getItems({}, 0, 200);
    setProducts(res.data.products || []);
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleAction = (action, type = null) => {
    if (type === "payment-in" || type === "payment-out") {
      setPaymentType(type);
      setShowPaymentModal(true);
    } else if (type === "create-sale-order") {
      setShowSaleOrderModal(true);
    } else if (type === "create-purchase-order") {
      setShowPurchaseOrderModal(true);
    } else {
      navigate(action);
      onHide();
    }
  };

  const transactionOptions = {
    purchase: [
      { name: "Purchase", icon: "bi bi-cart", action: "/purchases/create" },
      {
        name: "Payment-Out",
        icon: "bi bi-arrow-up-circle",
        type: "payment-out",
      },
      {
        name: "Purchase-Order",
        icon: "bi bi-file-text",
        // type: "create-purchase-order",
        action: "/purchases/order",
      },
    ],
    sale: [
      {
        name: "Sale-Order",
        icon: "bi bi-receipt",
        action: "/sales/order",
      },
      {
        name: "Payment-In",
        icon: "bi bi-arrow-down-circle",
        type: "payment-in",
      },
      // {
      //   name: "Sale-Invoice",
      //   icon: "bi bi-journal-text",
      //   action: "/sale-invoice",
      // },
    ],
    other: [
      { name: "Expenses", icon: "bi bi-wallet", action: "/create-expense" },
      {
        name: "Party-to-Party Transfer",
        icon: "bi bi-arrow-left-right",
        action: "/party-to-party-transfer",
      },
    ],
    stock: [
      {
        name: "Update Stock",
        icon: "bi bi-plus-circle",
        action: "addstock",
        // onClick: () => navigate("/products?mode=add-stock"),
      },
    ],
  };

  return (
    <>
      <style>
        {`
          .transaction-icon {
            cursor: pointer;
            transition: transform 0.2s, color 0.2s;
          }
          .transaction-icon:hover {
            transform: scale(1.06);
            color: #007bff;
          }
          .transaction-icon i {
            font-size: 2rem;
          }
          .transaction-icon span {
            font-size: 0.9rem;
            margin-top: 0.5rem;
            display: block;
          }
        `}
      </style>
      <div
        className={`modal fade ${show && !openModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{ backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-custom text-white">
              <h5 className="modal-title" style={{ fontSize: "16px" }}>
                Transactions
              </h5>
              <button
                type="button"
                className="btn text-light ms-auto bg-transparent border-0"
                style={{
                  fontSize: "16px",
                  padding: "2px 10px",
                  borderRadius: "0%",
                }}
                onClick={onHide}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-4">
                <p className="fw-bold">Purchase Transactions</p>
                <div className="d-flex flex-wrap gap-3 ">
                  {transactionOptions.purchase.map((option, index) => (
                    <div
                      key={index}
                      className="transaction-icon text-center"
                      onClick={() => handleAction(option.action, option.type)}
                    >
                      <i
                        className={option.icon}
                        style={{ fontSize: "20px" }}
                      ></i>
                      <span>{option.name}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mb-4">
                <p className="fw-bold">Sale Transactions</p>
                <div className="d-flex flex-wrap gap-3 ">
                  {transactionOptions.sale.map((option, index) => (
                    <div
                      key={index}
                      className="transaction-icon text-center"
                      onClick={() => handleAction(option.action, option.type)}
                    >
                      <i
                        className={option.icon}
                        style={{ fontSize: "20px" }}
                      ></i>
                      <span>{option.name}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="d-flex flex-wrap gap-3 ">
                {transactionOptions.stock.map((option, index) => (
                  <div
                    key={index}
                    className="transaction-icon text-center"
                    onClick={() => {
                      if (option.action === "addstock") {
                        setOpenModal(true);
                      } else {
                        handleAction(option.action, option.type);
                      }
                    }}
                  >
                    <i className={option.icon} style={{ fontSize: "20px" }}></i>
                    <span>{option.name}</span>
                  </div>
                ))}
              </div>

              {/* <div>
                <p className="fw-bold">Other Transactions</p>
                <div className="d-flex flex-wrap gap-3">
                  {transactionOptions.other.map((option, index) => (
                    <div
                      key={index}
                      className="transaction-icon text-center"
                      onClick={() => handleAction(option.action, option.type)}
                      style={{ width: "150px" }}
                    >
                      <i
                        className={option.icon}
                        style={{ fontSize: "20px" }}
                      ></i>
                      <span
                        style={{
                          display: "block",
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                        }}
                      >
                        {option.name}
                      </span>
                    </div>
                  ))}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Payment Modal */}
      {showPaymentModal && (
        <PaymentModal
          party={party}
          paymentType={paymentType} // pass selected type
          onClose={() => setShowPaymentModal(false)}
          onPaymentSuccess={onPaymentSuccess}
        />
      )}

      {showSaleOrderModal && (
        <SaleOrderModal
          isOpen={showSaleOrderModal}
          onClose={() => setShowSaleOrderModal(false)}
        />
      )}

      {showPurchaseOrderModal && (
        <PurchaseOrderModal
          isOpen={showPurchaseOrderModal}
          onClose={() => setShowPurchaseOrderModal(false)}
        />
      )}
      {openModal && (
        <AddStockModal
          allProducts={products}
          onClose={() => setOpenModal(false)}
          onUpdated={fetchProducts}
        />
      )}
    </>
  );
};

export default TransactionModal;
